module.exports = __webpack_public_path__ + "img/log1.61f49ce0.png";